import React, { useContext } from 'react';

import { OrganizationsApi } from '../apis';
import { api } from '../api';

const OrganizationsApiContext = React.createContext(new OrganizationsApi(api));

export const OrganizationsApiProvider = OrganizationsApiContext.Provider;
export const useOrganizationsApi = (): OrganizationsApi =>
  useContext(OrganizationsApiContext);
